import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import Assets from "./components/Assets";
import Attendance from "./components/Attendance";
import Broadcasts from "./components/Broadcasts";
import Dashboard from "./components/Dashboard";
import Employees from "./components/Employees";
import Goals from "./components/Goals";
import History from "./components/History";
import LeadsWrapper from "./components/LeadsWrapper";
import Leaves from "./components/Leaves";
import Login from "./components/Login";
import Navbar from "./components/Navbar";
import Payroll from "./components/Payroll";
import MyPayslip from "./components/MyPayslip";
import Profile from "./components/Profile";
import Projects from "./components/Projects";
import Requests from "./components/Requests";
import Roles from "./components/Roles";
import SalesTeams from "./components/SalesTeams";
import SalesReportsDashboard from "./components/SalesReportsDashboard";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Devices from "./components/biometric/Devices";
import BiometricAttendance from "./components/biometric/Attendance";
import Documents from "./components/Documents";
import MyDocuments from "./components/MyDocuments";
import Proposals from "./components/Proposals";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  return user ? children : <Navigate to="/login" />;
}

function AppContent() {
  const { user } = useAuth();

  return (
    <>
      {user && <Navbar />}
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/broadcasts"
          element={
            <PrivateRoute>
              <Broadcasts />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <PrivateRoute>
              <Projects />
            </PrivateRoute>
          }
        />
        <Route
          path="/goals"
          element={
            <PrivateRoute>
              <Goals />
            </PrivateRoute>
          }
        />
        <Route
          path="/assets"
          element={
            <PrivateRoute>
              <Assets />
            </PrivateRoute>
          }
        />
        <Route
          path="/leaves"
          element={
            <PrivateRoute>
              <Leaves />
            </PrivateRoute>
          }
        />
        <Route
          path="/requests"
          element={
            <PrivateRoute>
              <Requests />
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance"
          element={
            <PrivateRoute>
              <Attendance />
            </PrivateRoute>
          }
        />
        <Route
          path="/history"
          element={
            <PrivateRoute>
              <History />
            </PrivateRoute>
          }
        />
        <Route
          path="/leads"
          element={
            <PrivateRoute>
              <LeadsWrapper />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/roles"
          element={
            <PrivateRoute>
              <Roles />
            </PrivateRoute>
          }
        />
        <Route
          path="/employees"
          element={
            <PrivateRoute>
              <Employees />
            </PrivateRoute>
          }
        />
        <Route
          path="/documents"
          element={
            <PrivateRoute>
              <Documents />
            </PrivateRoute>
          }
        />
        <Route
          path="/my-documents"
          element={
            <PrivateRoute>
              <MyDocuments />
            </PrivateRoute>
          }
        />
        <Route
          path="/payroll"
          element={
            <PrivateRoute>
              <Payroll />
            </PrivateRoute>
          }
        />
        <Route
          path="/devices"
          element={
            <PrivateRoute>
              <Devices />
            </PrivateRoute>
          }
        />
        <Route
          path="/biometric-attendance"
          element={
            <PrivateRoute>
              <BiometricAttendance />
            </PrivateRoute>
          }
        />
        <Route
          path="/my-payroll"
          element={
            <PrivateRoute>
              <MyPayslip />
            </PrivateRoute>
          }
        />
        <Route
          path="/sales-teams"
          element={
            <PrivateRoute>
              <SalesTeams />
            </PrivateRoute>
          }
        />
        <Route
          path="/sales-reports"
          element={
            <PrivateRoute>
              <SalesReportsDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/proposals"
          element={
            <PrivateRoute>
              <Proposals />
            </PrivateRoute>
          }
        />

      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
